import { useState } from 'react'
import { useAsync } from 'react-use'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal as ModalAntd,
  notification,
  Radio,
  Row,
  Space,
  Tooltip,
  Typography,
} from 'antd'
import {
  CaretRightOutlined,
  CaretDownOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { useStoreState } from 'easy-peasy'

import _ from 'lodash'

import Card from 'components/Card'
import FilterReportStatusSelect from 'components/FilterReportStatusSelect'
import FilterReportTypeSelect from 'components/FilterReportTypeSelect'
import FilterTaskStatusSelect from 'components/FilterTaskStatusSelect'
import Input from 'components/Input'
import Modal from 'components/Modal'
import Page from 'components/Page'
import SearchOrganization from 'components/SearchOrganization'
import Select from 'components/Select'
import Table from 'components/Table'
import TableCorrective from 'components/TableCorrective'
import TextArea from 'components/TextArea'
import Upload from 'components/Upload'

import Styled from './styled'

import { useTranslate } from 'hooks/translate'

import { getDefaultDescriptionApi } from 'services/incident'
import {
  createTaskApi,
  deleteTaskApi,
  getIncidentApi,
  getTaskApi,
  updateTaskApi,
} from 'services/reportTask'
import { getUserFilterList } from 'services/myIncident'
import { getAllUser } from 'services/user'
import { getValueListApi, getValueListByTypeCodeApi } from 'services/value_list'
import {
  getReportAttachmentApi,
  postReportAttachmentApi,
  deleteReportAttachmentApi,
} from 'services/ReportAttachment'
import { getRiskOwnerOrgFilterList } from 'services/myIncident'

import { convertOrganizationalStructureToFilters } from 'utils/organization'

import moment from 'utils/moment'

const { RangePicker } = DatePicker
const DATE_FORMAT = 'YYYY-MM-DD'
const DEFAULT_PAGE_SIZE = 10

export default function IndexTest () {
  const { t } = useTranslate()

  const { incidentDashboardFilters } = useStoreState((store) => store.monthlyDashboard)

  const [form] = Form.useForm()

  const [isLoading, setLoading] = useState(false)
  const [isParentLoading, setParentLoading] = useState(false)
  const [isCreated, setCreated] = useState(false)
  const [isEdited, setEdited] = useState(false)
  const [isEditedTaskType, setEditedTaskType] = useState(false)
  const [isAnswer, setAnswer] = useState(false)
  const [editedAssignee, setEditedAssignee] = useState(false)
  const [taskLoading, setTaskLoading] = useState(false)

  const [dataSource, setDataSource] = useState([])
  const [anotherSource, setAnotherSource] = useState([])
  const [parentId, setParentId] = useState(null)
  const [editingId, setEditingId] = useState(null)
  const [taskTypeId, setTaskTypeId] = useState(null)
  const [assigneeId, setAssigneeId] = useState(null)
  const [anotherTask, setAnotherTask] = useState(false)
  const [subTask, setSubTask] = useState(false)

  const [showIncidentModal, setShowIncidentModal] = useState(false)
  const [parentList, setParentList] = useState([])
  const [anotherParentList, setAnotherParentList] = useState([])
  const [taskTypeList, setTaskTypeList] = useState([])
  const [allUser, setAllUser] = useState([])
  const [priorityList, setPriorityList] = useState([])
  const [statusList, setStatusList] = useState([])
  const [filterValue, setFilterValue] = useState({})
  const filterTask = {
    not_incident: true,
    me_only: true,
    parent_only: true,
  }
  const [filters, setFilters] = useState({
    incident_topic: null,
    has_task: true,
    parent_only: true,
    page: 1,
    size: DEFAULT_PAGE_SIZE,
  })
  const [filterMonthly, setFilterMonthly] = useState('')
  const [total, setTotal] = useState(0)

  const [reportHeaderId, setReportHeaderId] = useState(null)
  const [fileList, setFileList] = useState([])
  const [labelName, setLabelName] = useState(t('ชื่อแผนงาน'))
  // const [defaultDescription, setDefaultDescription] = useState('')
  const user = JSON.parse(localStorage.getItem('user'))
  const [assigneeList, setAssigneeList] = useState([])
  const org = JSON.parse(localStorage.getItem('org'))
  const isRiskAnalyst =
    JSON.parse(localStorage.getItem('user'))?.profile?.role?.role_name === 'Risk Analyst'

  const handleSubmit = (event) => {
    // console.log('event', event)
    const reporter = [
      'reporter_company_id',
      'reporter_group_id',
      'reporter_bu_id',
      'reporter_division_id',
      'reporter_department_id',
      'reporter_section_id',
    ]
    const riskco = [
      'risk_co_company_id',
      'risk_co_group_id',
      'risk_co_bu_id',
      'risk_co_division_id',
      'risk_co_department_id',
      'risk_co_section_id',
    ]
    const riskowner = [
      'risk_owner_company_id',
      'risk_owner_group_id',
      'risk_owner_bu_id',
      'risk_owner_division_id',
      'risk_owner_department_id',
      'risk_owner_section_id',
    ]
    const reporterFilters = convertOrganizationalStructureToFilters(
      event.reporter_company_id,
      reporter
    )
    const riskcoFilters = convertOrganizationalStructureToFilters(event.risk_co_company_id, riskco)
    const riskownerFilters = convertOrganizationalStructureToFilters(
      event.risk_owner_company_id,
      riskowner
    )
    const [date_from, date_to] = event.date_from || []
    setFilterValue({
      ...filterValue,
      ...event,
      ...reporterFilters,
      ...riskcoFilters,
      ...riskownerFilters,
      date_from: date_from?.format(DATE_FORMAT),
      date_to: date_to?.format(DATE_FORMAT),
    })
    // console.log({
    //   ...filterValue,
    //   ...event,
    //   ...reporterFilters,
    //   ...riskcoFilters,
    //   ...riskownerFilters,
    //   date_from: date_from?.format(DATE_FORMAT),
    //   date_to: date_to?.format(DATE_FORMAT),
    // })
  }

  const getIncidentList = async () => {
    if (isLoading) return
    const params = {
      ...filters,
      ...filterValue,
      date_from: filterValue?.date_from
        ? filterValue?.date_from
        : // : incidentDashboardFilters?.date_from
          // ? moment(incidentDashboardFilters?.date_from).format(DATE_FORMAT)
          moment().startOf('year').format(DATE_FORMAT),
      date_to: filterValue?.date_to
        ? filterValue?.date_to
        : // : incidentDashboardFilters?.date_to
          // ? moment(incidentDashboardFilters?.date_to).format(DATE_FORMAT)
          moment().format(DATE_FORMAT),
    }

    setLoading(true)

    const res = await getIncidentApi(params)
    // console.log('incident', res.data?.items)

    setLoading(false)

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })
      return
    }
    // filter report_task with no parent_task_id
    const data = _.map(res.data?.items, (items) => {
      return {
        ...items,
        report_task: _.filter(items.report_task, (item) => item.parent_task_id === null),
      }
    })

    setDataSource(data)
    setTotal(res.data?.total)
  }

  const getTaskList = async () => {
    if (taskLoading) return

    const params = {
      ...filterValue,
      ...filterTask,
      ...filters,
      date_from: filterValue?.date_from
        ? filterValue?.date_from
        : // : incidentDashboardFilters?.date_from
          // ? moment(incidentDashboardFilters?.date_from).format(DATE_FORMAT)
          moment().startOf('year').format(DATE_FORMAT),
      date_to: filterValue?.date_to
        ? filterValue?.date_to
        : // : incidentDashboardFilters?.date_to
          // ? moment(incidentDashboardFilters?.date_to).format(DATE_FORMAT)
          moment().format(DATE_FORMAT),
    }

    if (filterMonthly !== '') {
      params.task_type_code = 'TTF'
    }

    setTaskLoading(true)

    const res = await getTaskApi(params)
    // console.log('another', res.data)

    setTaskLoading(false)

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })

      return
    }

    setAnotherSource(res.data)
  }

  const getTaskTypeList = async () => {
    const typeId = await getValueListByTypeCodeApi('TKT')
    const res = await getValueListApi(typeId.data?.value_list_type_id)
    const formatValue = _.map(res.data, (item) => {
      return {
        label: item.name,
        value: item.id,
      }
    })
    setTaskTypeList(formatValue)
  }

  const getParentList = async () => {
    if (isParentLoading) return

    const params = {
      ...filterValue,
      ...filters,
    }

    setParentLoading(true)

    const res = await getIncidentApi(params)

    setParentLoading(false)

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })
      return
    }

    const filterTask = _.find(res.data?.items, (item) => item.report_header_id === reportHeaderId)
    // console.log('filterTask', filterTask)
    if (filterTask) {
      const data = _.filter(filterTask.report_task, (item) => item.parent_task_id === null)
      const formatValue = _.map(data, (item) => {
        return {
          label: `แผนงานย่อยของ ${item?.task_name}`,
          value: item?.id,
        }
      })
      formatValue.push({ label: 'This is Parent Task', value: null })
      setParentList(formatValue)
    } else {
      setParentList([{ label: 'This is Parent Task', value: null }])
    }
  }

  const getAnotherParentList = async () => {
    if (isParentLoading) return

    const params = {
      ...filterValue,
      ...filterTask,
    }

    setParentLoading(true)

    const res = await getTaskApi(params)

    setParentLoading(false)

    let formatValue = []
    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })
      return
    }

    if (res?.data) {
      formatValue = _.map(res?.data, (item) => {
        return {
          label: `แผนงานย่อยของ ${item?.task_name}`,
          value: item?.id,
        }
      })
      formatValue.push({ label: t('This is Parent Task'), value: null })
    } else {
      formatValue.push({ label: t('This is Parent Task'), value: null })
    }

    setAnotherParentList(formatValue)
  }

  const getAllUserDropdown = async () => {
    const res = await getAllUser()

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })

      return
    }

    const userList = _.map(res.data, (item) => {
      return { label: item?.employee.employee_name_th, value: item?.user_id }
    })

    setAllUser(userList)
  }

  const getValueDropdown = async () => {
    const priorityList = await getValueListApi(5)
    const statusList = await getValueListApi(6)
    const formatPriorityList = _.map(priorityList.data, (item) => {
      return { label: item.name, value: item.id }
    })
    const formatStatusList = _.map(statusList.data, (item) => {
      return { label: item.name, value: item.id }
    })
    setPriorityList(_.sortBy(formatPriorityList, [(item) => item.value]))
    setStatusList(_.sortBy(formatStatusList, [(item) => item.value]))
  }

  const createTask = async (values) => {
    // console.log(parentId, values)
    const res = await createTaskApi({
      report_header_id: reportHeaderId,
      parent_task_id: values?.parent,
      task_name: values?.name,
      task_description: values?.description,
      task_assignee_id: values?.assignee,
      task_start_date: values?.startDate.format('YYYY-MM-DD'),
      task_due_date: values?.dueDate ? values?.dueDate.format('YYYY-MM-DD') : '',
      task_type_id: values?.taskType,
      task_status_id: values?.status,
      task_priority_id: values?.priority,
      task_result: values?.result,
    })

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })
      return
    } else {
      if (values.files != null) {
        uploadFiles(values.files, reportHeaderId, res?.data?.report_task_id, null)
      }
      notification.success({
        message: t('Success'),
        description: res.message,
      })
    }

    getIncidentList()
    getTaskList()

    setShowIncidentModal(false)
    setCreated(false)
    form.resetFields()
  }

  const createAnotherTask = async (values) => {
    const res = await createTaskApi({
      report_header_id: reportHeaderId,
      parent_task_id: values?.parent,
      task_name: values?.name,
      task_description: values?.description,
      task_assignee_id: values?.assignee,
      task_start_date: values?.startDate.format('YYYY-MM-DD'),
      task_due_date: values?.dueDate ? values?.dueDate.format('YYYY-MM-DD') : '',
      task_type_id: values?.taskType,
      task_status_id: values?.status,
      task_priority_id: values?.priority,
      task_result: values?.result,
    })

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })
      return
    } else {
      if (values.files != null) {
        uploadFiles(values.files, reportHeaderId, res?.data?.report_task_id, null)
      }
      notification.success({
        message: t('Success'),
        description: res.message,
      })
    }

    getIncidentList()
    getTaskList()

    setCreated(false)
    setAnotherTask(false)
    setShowIncidentModal(false)

    form.resetFields()
  }

  const updateTask = async (id, values) => {
    const res = await updateTaskApi(id, {
      report_header_id: reportHeaderId,
      parent_task_id: parentId,
      task_name: values?.name,
      task_description: values?.description,
      task_assignee_id: values?.assignee,
      task_start_date: values?.startDate.format('YYYY-MM-DD'),
      task_due_date: values?.dueDate ? values?.dueDate.format('YYYY-MM-DD') : '',
      task_type_id: values?.taskType,
      task_status_id: values?.status,
      task_priority_id: values?.priority,
      task_result: values?.result,
    })

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })
      return
    } else {
      if (values.files != null) {
        console.log(values.files, reportHeaderId, id, res.data)
        uploadFiles(values.files, reportHeaderId, id, null)
      }
      notification.success({
        message: t('Updated Success'),
        description: res.message,
      })
    }

    getIncidentList()
    getTaskList()

    setShowIncidentModal(false)

    form.resetFields()
  }

  const deleteTask = async (id) => {
    const res = await deleteTaskApi(id)

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })

      return
    } else {
      deleteFileNotUse([])
      notification.success({
        message: t('Success'),
        description: res.message,
      })
    }

    getIncidentList()
    getTaskList()
  }

  const getFile = async (report_task_id) => {
    setFileList([])
    const filesRes = await getReportAttachmentApi({
      report_header_id: reportHeaderId,
      report_task_id: report_task_id,
      report_attribute_value_id: null,
    })

    const tempData = []

    filesRes?.data.map((item) => {
      tempData.push({
        uid: item?.report_attachment_id,
        name: item?.file_path.substring(item?.file_path.lastIndexOf('/') + 1),
        status: 'done',
        url: `${process.env.REACT_APP_SERVICE_URL}${item.file_path}`,
      })
    })

    setFileList(tempData)

    return tempData
  }

  const uploadFiles = async (
    files,
    report_header_id,
    report_task_id,
    report_attribute_value_id
  ) => {
    const uploadFile = []
    const oldFile = []

    files.map((item) => {
      if (item?.status === 'done') {
        oldFile.push(item.uid)
      } else {
        uploadFile.push(item.originFileObj)
      }
    })

    if (oldFile.length > 0) deleteFileNotUse(oldFile)

    if (files.length === 0) deleteFileNotUse([])

    if (uploadFile.length > 0) {
      const res = await postReportAttachmentApi(uploadFile, {
        report_header_id: report_header_id,
        report_task_id: report_task_id,
        report_attribute_value_id: report_attribute_value_id,
      })

      if (res.status === 'error') {
        notification.error({
          message: t('Failed'),
          description: res.message,
        })
        return
      }
    }
  }

  const deleteFileNotUse = async (noDelIds) => {
    const delIds = []
    _.map(fileList, (item) => {
      if (noDelIds.includes(item.uid)) {
      } else {
        delIds.push(item.uid)
      }
    })

    if (delIds.length > 0) {
      const res = await deleteReportAttachmentApi(delIds)

      if (res.status === 'error') {
        notification.error({
          message: t('Failed'),
          description: res.message,
        })

        return
      }
    }
  }

  // const getDefaultDescription = async () => {
  //   if (reportHeaderId) {
  //     const res = await getDefaultDescriptionApi(reportHeaderId)
  //     if (res.status === 'error') {
  //       notification.error({
  //         message: t('Failed'),
  //         description: res.message,
  //       })
  //       return
  //     }
  //     console.log(res.data)
  //     setDefaultDescription(res.data)
  //   }
  // }

  const getAssigneeList = async () => {
    console.log('org', org, 'user', user)
    let roleID = user?.profile?.role_id
    let params = {}
    if ([1, 2, 8].includes(roleID)) {
      params = {
        user_id: user?.user_id,
      }
    } else if (roleID === 3) {
      params = {
        role_id: [1, 2, 3, 8],
        is_pool_org_code: org?.is_pool_org_code,
      }
    } else if (roleID === 6) {
      params = {
        role_id: [1, 2, 3, 6, 8],
        is_pool_org_code: org?.is_pool_org_code,
      }
    } else if (roleID === 7) {
      params = {
        is_pool_org_code: org?.is_pool_org_code,
      }
    }
    const res = await getUserFilterList({
      ...params,
    })
    if (res?.status === 'success' && res?.data) {
      let data = res?.data.map((item) => {
        return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
      })
      setAssigneeList(data)
    }
  }

  useAsync(async () => {
    getTaskTypeList()
    getAllUserDropdown()
    getValueDropdown()
    getAssigneeList()
  }, [])

  useAsync(async () => {
    getIncidentList()
    getTaskList()
  }, [filters, filterValue])

  useAsync(async () => {
    getTaskList()
  }, [filterMonthly])

  useAsync(async () => {
    getParentList()
    getAnotherParentList()
    // getDefaultDescription()
  }, [reportHeaderId, anotherTask, subTask])

  const columns = [
    {
      title: t('Topic'),
      dataIndex: 'topic',
      key: 'topic',
      className: 'bold',
      width: '20%',
      sorter: (a, b) => {
        return `${a?.topic || ''}`.localeCompare(b?.topic || '')
      },
      render: (text) => {
        return <Typography.Text style={{ wordBreak: 'break-all' }}>{text}</Typography.Text>
      },
    },
    {
      title: t('Reporter'),
      dataIndex: 'reporter',
      key: 'reporter',
      width: '15%',
      sorter: (a, b) => {
        return `${a?.reporter || ''}`.localeCompare(b?.reporter || '')
      },
    },
    {
      title: t('Risk Owner'),
      dataIndex: 'risk_owner',
      key: 'risk_owner',
      sorter: (a, b) => {
        return `${a?.risk_owner || ''}`.localeCompare(b?.risk_owner || '')
      },
    },
    {
      title: t('Report Type'),
      dataIndex: 'reportType',
      key: 'reportType',
      sorter: (a, b) => {
        return `${a?.reportType || ''}`.localeCompare(b?.reportType || '')
      },
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
      width: '5%',
      sorter: (a, b) => {
        return `${a?.status || ''}`.localeCompare(b?.status || '')
      },
    },
    {
      title: t('AP Status'),
      dataIndex: 'apStatus',
      key: 'apStatus',
      sorter: (a, b) => {
        return `${a?.apStatus || ''}`.localeCompare(b?.apStatus || '')
      },
    },
  ]

  const correctiveIncidentColumn = [
    {
      title: t('Task Name'),
      dataIndex: 'task_name',
      key: 'task_name',
      className: 'bold',
      width: '20%',
      sorter: (a, b) => {
        return `${a?.task_name || ''}`.localeCompare(b?.task_name || '')
      },
      render: (text) => {
        return <Typography.Text style={{ wordBreak: 'break-all' }}>{text}</Typography.Text>
      },
    },
    {
      title: t('Description'),
      dataIndex: 'description',
      key: 'description',
      width: '20%',
      sorter: (a, b) => {
        return `${a?.description || ''}`.localeCompare(b?.description || '')
      },
      render: (text) => {
        return <Typography.Text style={{ wordBreak: 'break-all' }}>{text}</Typography.Text>
      },
    },
    {
      title: t('Assignee'),
      dataIndex: 'assignee_name',
      key: 'assignee_name',
      width: '15%',
      sorter: (a, b) => {
        return `${a?.assignee_name || ''}`.localeCompare(b?.assignee_name || '')
      },
    },
    {
      title: t('Priority'),
      dataIndex: 'priority',
      key: 'priority',
      width: '5%',
      sorter: (a, b) => {
        return `${a?.priority || ''}`.localeCompare(b?.priority || '')
      },
    },
    {
      title: t('Due Date'),
      dataIndex: 'dueDate',
      key: 'dueDate',
      width: '13%',
      sorter: (a, b) => {
        return `${a?.dueDate || ''}`.localeCompare(b?.dueDate || '')
      },
      render: (text, record) => {
        if (record?.isOverdue) {
          return (
            <Typography.Text type='danger' strong>
              {text} <ExclamationCircleOutlined />
            </Typography.Text>
          )
        } else {
          return <Typography.Text>{text}</Typography.Text>
        }
      },
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
      sorter: (a, b) => {
        return `${a?.status || ''}`.localeCompare(b?.status || '')
      },
    },
    {
      title: t('Actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '5%',
      render: (text, record) => {
        return (
          <Space size='small'>
            <Tooltip title={t('Create')}>
              <Button
                type='link'
                icon={<EditOutlined />}
                onClick={async () => {
                  setLabelName(t('ชื่อแผนงาน'))
                  setCreated(true)
                  setReportHeaderId(record?.report_header_id)
                  setParentId(null)
                  setTaskTypeId(record?.task_type_id)

                  const res = await getDefaultDescriptionApi(record?.report_header_id)

                  form.setFieldsValue({
                    parent: record?.id,
                    taskType: record?.task_type_id,
                    description: res?.data,
                    assignee: record?.assignee_id,
                    startDate: moment(),
                  })

                  setShowIncidentModal(true)
                }}
                disabled={record?.isEdit ? false : true}
              />
            </Tooltip>
            <Tooltip title={t('Edit')}>
              <Button
                type='link'
                icon={<SettingOutlined />}
                onClick={async () => {
                  // console.log('Edit', record)
                  setLabelName(t('ชื่อแผนงาน'))
                  setReportHeaderId(record?.report_header_id)
                  setParentId(record?.parent_task_id)
                  setEditingId(record?.id)
                  setEdited(record?.isEdit)
                  setAnswer(record?.isAnswer)

                  const files = await getFile(record?.id)

                  form.setFieldsValue({
                    parent: record?.parent_task_id,
                    taskType: record?.task_type_id,
                    name: record?.task_name,
                    description: record?.description,
                    assignee: record?.assignee_id,
                    startDate: record?.startDate ? moment(record?.startDate) : '',
                    dueDate: record?.dueDate ? moment(record?.dueDate) : '',
                    priority: record?.task_priority,
                    status: record?.task_status_id,
                    result: record?.result,
                    files: files,
                  })

                  setShowIncidentModal(true)
                }}
              />
            </Tooltip>
            <Tooltip title={t('Delete')}>
              <Button
                type='link'
                danger
                icon={<DeleteOutlined />}
                onClick={() => {
                  ModalAntd.confirm({
                    title: t('Confirm deletion'),
                    icon: null,
                    maskClosable: true,
                    closeIcon: true,
                    content: (
                      <div>
                        <dl>
                          <dt>{t('Name')}</dt>
                          <dd>- {record?.task_name}</dd>
                          <dt>{t('Assignee')}</dt>
                          <dd>- {record?.assignee_name}</dd>
                        </dl>
                      </div>
                    ),
                    okButtonProps: {
                      shape: 'round',
                    },
                    okText: t('Delete'),
                    okType: 'primary',
                    cancelButtonProps: {
                      shape: 'round',
                    },
                    cancelText: t('Cancel'),
                    onOk: async () => {
                      await deleteTask(record?.id)
                    },
                  })
                }}
                disabled={record?.isEdit ? false : true}
              />
            </Tooltip>
          </Space>
        )
      },
    },
  ]

  const anotherTaskColumn = [
    {
      title: t('Task Name'),
      dataIndex: 'task_name',
      key: 'task_name',
      className: 'bold',
      width: '20%',
      sorter: (a, b) => {
        return `${a?.task_name || ''}`.localeCompare(b?.task_name || '')
      },
      render: (text) => {
        return <Typography.Text style={{ wordBreak: 'break-all' }}>{text}</Typography.Text>
      },
    },
    {
      title: t('Description'),
      dataIndex: 'description',
      key: 'description',
      width: '20%',
      sorter: (a, b) => {
        return `${a?.description || ''}`.localeCompare(b?.description || '')
      },
      render: (text) => {
        return <Typography.Text style={{ wordBreak: 'break-all' }}>{text}</Typography.Text>
      },
    },
    {
      title: t('Assignee'),
      dataIndex: 'assignee_name',
      key: 'assignee_name',
      width: '15%',
      sorter: (a, b) => {
        return `${a?.assignee_name || ''}`.localeCompare(b?.assignee_name || '')
      },
    },
    {
      title: t('Priority'),
      dataIndex: 'priority',
      key: 'priority',
      sorter: (a, b) => {
        return `${a?.priority || ''}`.localeCompare(b?.priority || '')
      },
    },
    {
      title: t('Due Date'),
      dataIndex: 'dueDate',
      key: 'dueDate',
      width: '13%',
      sorter: (a, b) => {
        return `${a?.dueDate || ''}`.localeCompare(b?.dueDate || '')
      },
      render: (text, record) => {
        if (record?.isOverdue) {
          return (
            <Typography.Text type='danger' strong>
              {text} <ExclamationCircleOutlined />
            </Typography.Text>
          )
        } else {
          return <Typography.Text>{text}</Typography.Text>
        }
      },
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
      sorter: (a, b) => {
        return `${a?.status || ''}`.localeCompare(b?.status || '')
      },
    },
    {
      title: t('Actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '5%',
      render: (text, record) => {
        return (
          <Space size='small'>
            <Tooltip title={t('Create')}>
              <Button
                type='link'
                icon={<EditOutlined />}
                onClick={async () => {
                  setCreated(true)
                  setAnotherTask(true)
                  setReportHeaderId(record?.report_header_id)
                  setParentId(record?.id)
                  setTaskTypeId(record?.task_type_id)
                  setLabelName(t('ชื่อแผนงาน'))

                  const res = await getDefaultDescriptionApi(record?.report_header_id)

                  //set Task Type equal Parent Task
                  form.setFieldsValue({
                    parent: record?.id,
                    taskType: record?.task_type_id,
                    description: res?.data,
                    assignee: record?.assignee_id,
                    startDate: moment(),
                  })
                  setShowIncidentModal(true)
                }}
                disabled={record?.isEdit ? false : true}
              />
            </Tooltip>
            <Tooltip title={t('Edit')}>
              <Button
                type='link'
                icon={<SettingOutlined />}
                onClick={async () => {
                  // console.log('record', record)
                  setEditingId(record?.id)
                  setReportHeaderId(record?.report_header_id)
                  setParentId(record?.parent_task_id)
                  setEdited(record?.isEdit)
                  setAnswer(record?.isAnswer)
                  setLabelName(t('ชื่อแผนงาน'))

                  const files = await getFile(record?.id)

                  if (record?.task_type === 'TTF') {
                    form.setFieldsValue({
                      parent: record?.parent_task_id,
                      taskType: record?.task_type_id,
                      name: record?.task_name,
                      description: record?.description,
                      assignee: record?.assignee_id,
                      startDate: record?.startDate
                        ? moment(record?.startDate)
                        : moment().endOf('month'),
                      dueDate: record?.dueDate ? moment(record?.dueDate) : '',
                      priority: record?.task_priority,
                      status: record?.task_status_id,
                      result: record?.result,
                      files: files,
                    })
                  } else {
                    form.setFieldsValue({
                      parent: record?.parent_task_id,
                      taskType: record?.task_type_id,
                      name: record?.task_name,
                      description: record?.description,
                      assignee: record?.assignee_id,
                      startDate: record?.startDate ? moment(record?.startDate) : '',
                      dueDate: record?.dueDate ? moment(record?.dueDate) : '',
                      priority: record?.task_priority,
                      status: record?.task_status_id,
                      result: record?.result,
                      files: files,
                    })
                  }

                  setShowIncidentModal(true)
                }}
              />
            </Tooltip>
            <Tooltip title={t('Delete')}>
              <Button
                type='link'
                danger
                icon={<DeleteOutlined />}
                onClick={() => {
                  ModalAntd.confirm({
                    title: t('Confirm deletion'),
                    icon: null,
                    maskClosable: true,
                    closeIcon: true,
                    content: (
                      <div>
                        <dl>
                          <dt>{t('Name')}</dt>
                          <dd>- {record?.task_name}</dd>
                          <dt>{t('Assignee')}</dt>
                          <dd>- {record?.assignee_name}</dd>
                        </dl>
                      </div>
                    ),
                    okButtonProps: {
                      shape: 'round',
                    },
                    okText: t('Delete'),
                    okType: 'primary',
                    cancelButtonProps: {
                      shape: 'round',
                    },
                    cancelText: t('Cancel'),
                    onOk: async () => {
                      await deleteTask(record?.id)
                    },
                  })
                }}
                disabled={record?.isEdit ? false : true}
              />
            </Tooltip>
          </Space>
        )
      },
    },
  ]

  const subColumn = [
    {
      title: t('Task Name'),
      dataIndex: 'task_name',
      key: 'task_name',
      className: 'bold',
      width: '20%',
      render: (text) => {
        return <Typography.Text style={{ wordBreak: 'break-all' }}>{text}</Typography.Text>
      },
    },
    {
      title: t('Description'),
      dataIndex: 'description',
      key: 'description',
      width: '20%',
      render: (text) => {
        return <Typography.Text style={{ wordBreak: 'break-all' }}>{text}</Typography.Text>
      },
    },
    {
      title: t('Assignee'),
      dataIndex: 'assignee_name',
      key: 'assignee_name',
      width: '10%',
    },
    {
      title: t('Priority'),
      dataIndex: 'priority',
      key: 'priority',
      width: '5%',
    },
    {
      title: t('Due Date'),
      dataIndex: 'dueDate',
      key: 'dueDate',
      width: '13%',
      render: (text, record) => {
        if (record?.isOverdue) {
          return (
            <Typography.Text type='danger' strong>
              {text} <ExclamationCircleOutlined />
            </Typography.Text>
          )
        } else {
          return <Typography.Text>{text}</Typography.Text>
        }
      },
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: t('Actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '5%',
      render: (text, record) => {
        return (
          <Space size='small'>
            <Tooltip title={t('Edit')}>
              <Button
                type='link'
                icon={<SettingOutlined />}
                onClick={async () => {
                  setSubTask(true)
                  setEditingId(record.id)
                  setReportHeaderId(record?.report_header_id)
                  setParentId(record?.parent_task_id)
                  setEdited(record?.isEdit)
                  setAnswer(record?.isAnswer)
                  setLabelName(t('ชื่อแผนงาน'))

                  const files = await getFile(record?.id)

                  form.setFieldsValue({
                    parent: record?.parent_task_id,
                    taskType: record?.task_type_id,
                    name: record?.task_name,
                    assignee: record?.assignee_id,
                    description: record?.description,
                    startDate: record?.startDate ? moment(record?.startDate) : '',
                    dueDate: record?.dueDate ? moment(record?.dueDate) : '',
                    priority: record?.task_priority_id,
                    status: record?.task_status_id,
                    result: record?.result,
                    files: files,
                  })

                  setShowIncidentModal(true)
                }}
              />
            </Tooltip>
            <Tooltip title={t('Delete')}>
              <Button
                type='link'
                danger
                icon={<DeleteOutlined />}
                onClick={() => {
                  ModalAntd.confirm({
                    title: t('Confirm deletion'),
                    icon: null,
                    maskClosable: true,
                    closeIcon: true,
                    content: (
                      <div>
                        <dl>
                          <dt>{t('Name')}</dt>
                          <dd>- {record?.task_name}</dd>
                          <dt>{t('Assignee')}</dt>
                          <dd>- {record?.assignee_name}</dd>
                        </dl>
                      </div>
                    ),
                    okButtonProps: {
                      shape: 'round',
                    },
                    okText: t('Delete'),
                    okType: 'primary',
                    cancelButtonProps: {
                      shape: 'round',
                    },
                    cancelText: t('Cancel'),
                    onOk: async () => {
                      await deleteTask(record?.id)
                    },
                  })
                }}
                disabled={record?.isEdit ? false : true}
              />
            </Tooltip>
          </Space>
        )
      },
    },
  ]

  return (
    <Styled className='page-my-task'>
      <Page
        title={t('My Task')}
        searchPlaceholder={t('Search Incident Topic')}
        onSearch={(value) => {
          setFilters({
            ...filters,
            incident_topic: value,
            page: 1,
          })
        }}
      >
        <Space size='middle' direction='vertical' style={{ width: '100%' }}>
          <FilterComponent onChange={handleSubmit} assigneeList={assigneeList} />
          <Card title={t('Incident Report')}>
            <Table
              loading={isLoading}
              columns={columns}
              dataSource={dataSource}
              pagination={{
                current: filters.page,
                pageSize: filters.size,
                total,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal: (total) => t('Total ${total} items', { total }),
              }}
              onChange={(pagination) => {
                setFilters({
                  ...filters,
                  page: pagination.current,
                  size: pagination.pageSize,
                })
              }}
              scroll={{ x: 1100 }}
              expandable={{
                expandedRowRender: (record) => (
                  <Space direction='vertical' size={0} style={{ width: '100%' }}>
                    <TableCorrective
                      loading={isLoading}
                      correctiveColumn={correctiveIncidentColumn}
                      subColumn={subColumn}
                      dataSource={record.report_task}
                    />
                  </Space>
                ),
                expandIcon: ({ expanded, onExpand, record }) =>
                  expanded ? (
                    <CaretDownOutlined onClick={(e) => onExpand(record, e)} />
                  ) : (
                    <CaretRightOutlined onClick={(e) => onExpand(record, e)} />
                  ),
              }}
            />
          </Card>
          <Card
            title={t('Another Assigned Tasks')}
            // extra={
            //   <>
            //     <Radio.Group
            //       value={filterMonthly}
            //       options={[
            //         { label: t('All'), value: '' },
            //         { label: t('Monthly Confirmation'), value: 'monthly' },
            //       ]}
            //       onChange={(e) => {
            //         return setFilterMonthly(e?.target?.value)
            //       }}
            //       defaultValue='all'
            //       optionType='button'
            //       buttonStyle='solid'
            //     />
            //   </>
            // }
          >
            <Row justify='end'>
              <Col xs={24} sm={8} lg={6}>
                <Radio.Group
                  value={filterMonthly}
                  options={[
                    { label: t('All'), value: '' },
                    { label: t('Monthly Confirmation'), value: 'monthly' },
                  ]}
                  onChange={(e) => {
                    return setFilterMonthly(e?.target?.value)
                  }}
                  defaultValue='all'
                  optionType='button'
                  buttonStyle='solid'
                />
              </Col>
            </Row>
            <TableCorrective
              loading={taskLoading}
              correctiveColumn={anotherTaskColumn}
              subColumn={subColumn}
              dataSource={anotherSource}
              pagination={false}
              scroll={{ x: 1100 }}
            />
          </Card>
        </Space>
      </Page>
      <Modal
        width={600}
        visible={showIncidentModal}
        title={editingId ? t('Edit Task') : t('Create New Task')}
        onCancel={() => {
          setShowIncidentModal(false)
        }}
        afterClose={() => {
          if (editingId) {
            form.resetFields()
          }
          setCreated(false)
          setEditingId(null)
          setAnotherTask(false)
          setSubTask(false)
          setEditedAssignee(false)
        }}
        footer={[
          <Button
            key='create'
            type='primary'
            onClick={() => {
              form.submit()
            }}
            disabled={isCreated || isEdited || isAnswer || isRiskAnalyst ? false : true}
          >
            {editingId ? t('Update') : t('Create')}
          </Button>,
        ]}
      >
        <Form
          form={form}
          layout='vertical'
          onFinish={async (values) => {
            if (editingId) {
              updateTask(editingId, values)
            } else {
              anotherTask ? createAnotherTask(values) : createTask(values)
            }
          }}
        >
          <Row gutter={8}>
            <Col span={24}>
              <Form.Item label={t('Parent')} name='parent'>
                <Select
                  loading={isParentLoading}
                  options={anotherTask || subTask ? anotherParentList : parentList}
                  disabled={!isParentLoading && isCreated ? false : true}
                  onChange={(value) => {
                    if (value === null) {
                      setEditedAssignee(true)
                      setEditedTaskType(true)
                    } else {
                      setEditedAssignee(false)
                      setEditedTaskType(false)
                    }
                    if (anotherTask) {
                      const data = _.find(anotherSource, (item) => item.id === value)
                      setParentId(value)
                      setTaskTypeId(data?.task_type_id)
                      setAssigneeId(data?.assignee_id)
                    } else {
                      const data = _.find(dataSource, (items) => {
                        return _.find(items.report_task, (item) => item.id === value)
                      })
                      const findData = _.find(data?.report_task, (item) => item.id === value)
                      setParentId(value)
                      setTaskTypeId(findData?.task_type_id)
                      setAssigneeId(findData?.id)
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={t('Task Type')} name='taskType'>
                <Select
                  placeholder={t('Select Type')}
                  value={taskTypeId}
                  options={taskTypeList}
                  disabled={isCreated && isEditedTaskType ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={labelName}
                name='name'
                rules={[
                  {
                    required: true,
                    message: t('Please input name'),
                  },
                ]}
              >
                <Input disabled={isCreated || isEdited ? false : true} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={t('Description')} name='description'>
                <TextArea disabled={isCreated || isEdited ? false : true} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={t('Assignee')}
                name='assignee'
                rules={[
                  {
                    required: true,
                    message: t('Please select assignee'),
                  },
                ]}
              >
                <Select
                  placeholder={t('Select Assignee')}
                  value={assigneeId}
                  options={allUser}
                  disabled={(isCreated && editedAssignee) || isRiskAnalyst ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('Start Date')}
                name='startDate'
                rules={[
                  {
                    required: true,
                    message: t('Please select date'),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: '100%', borderRadius: '10px' }}
                  disabled={isCreated || isEdited ? false : true}
                  disabledDate={(current) => {
                    return moment().add(-1, 'days') >= current
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('Due Date')}
                name='dueDate'
                rules={[
                  {
                    required: true,
                    message: t('Please select date'),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: '100%', borderRadius: '10px' }}
                  disabled={isCreated || isEdited ? false : true}
                  disabledDate={(current) => {
                    return moment().add(-1, 'days') >= current
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('Priority')}
                name='priority'
                rules={[
                  {
                    required: true,
                    message: t('Please select priority'),
                  },
                ]}
              >
                <Radio.Group
                  options={priorityList}
                  optionType='button'
                  buttonStyle='solid'
                  disabled={isCreated || isEdited ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('Status')}
                name='status'
                rules={[
                  {
                    required: true,
                    message: t('Please select status'),
                  },
                ]}
              >
                <Select
                  placeholder={t('Select Status')}
                  options={statusList}
                  disabled={isCreated || isEdited || isAnswer ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={t('Result')} name='result'>
                <TextArea disabled={isCreated || isEdited || isAnswer ? false : true} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={t('Attach File')} name='files'>
                <Upload disabled={isCreated || isEdited || isAnswer ? false : true} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Styled>
  )
}

const FilterComponent = ({ onChange, assigneeList }) => {
  const { t } = useTranslate()
  const { incidentDashboardFilters } = useStoreState((store) => store.monthlyDashboard)
  const [RiskOwnerOrgList, setRiskOwnerOrgList] = useState([])

  const getRiskOwnerOrgList = async (isReportOwnself) => {
    const reportListRiskOwnerOrg = await getRiskOwnerOrgFilterList()
    const formatReportListStatus = _.map(reportListRiskOwnerOrg?.data, (item) => {
      return { ...item, label: item.level_org_name, value: item.level_org_code }
    })
    setRiskOwnerOrgList(formatReportListStatus)
  }

  useAsync(async () => {
    getRiskOwnerOrgList()
  }, [])

  return (
    <Form
      layout='horizontal'
      colon={false}
      name='search'
      initialValues={{
        // reporter_company_id: incidentDashboardFilters?.reporter_company_id,
        // risk_co_company_id: incidentDashboardFilters?.risk_co_company_id,
        // risk_owner_company_id: incidentDashboardFilters?.risk_owner_company_id,
        // report_type_id: incidentDashboardFilters?.report_type_id,
        // report_status_id: incidentDashboardFilters?.report_status_id,
        // task_status_id: incidentDashboardFilters?.task_status_id,
        date_from: [
          // incidentDashboardFilters?.date_from
          //   ? moment(incidentDashboardFilters?.date_from)
          //   :
          moment().startOf('year'),
          // incidentDashboardFilters?.date_to ? moment(incidentDashboardFilters?.date_to) :
          moment(),
        ],
      }}
      onFinish={onChange}
    >
      <Row gutter={8}>
        <Col span={22}>
          <Row gutter={8}>
            <Col xs={24} lg={12}>
              <Form.Item labelCol={{ span: 4 }} name='reporter_company_id' label={t('Reporter')}>
                <SearchOrganization />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item name='risk_co_company_id' label={t('Risk Co')}>
                <SearchOrganization />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col xs={24} lg={12}>
              <Form.Item
                name='risk_owner_company_id'
                labelCol={{ span: 4 }}
                label={t('Risk Owner')}
              >
                <Select options={RiskOwnerOrgList} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={8}>
              <Form.Item name='date_from' label={t('Report From - to')}>
                <RangePicker allowClear={false} format={DATE_FORMAT} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col xs={24} lg={12}>
              <Form.Item name='report_type_id' labelCol={{ span: 4 }} label={t('Report Type')}>
                <FilterReportTypeSelect att={{ mode: 'multiple' }} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={4}>
              <Form.Item name='report_status_id'>
                <FilterReportStatusSelect att={{ mode: 'multiple' }} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={4}>
              <Form.Item name='task_status_id'>
                <FilterTaskStatusSelect att={{ mode: 'multiple' }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12}>
              <Form.Item name='assignee_id' labelCol={{ span: 4 }} label='Assignee'>
                <Select options={assigneeList} />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col xs={24} lg={2}>
          <Button type='primary' htmlType='submit'>
            {t('Search')}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
